module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./RoleListView.js"));
	}, "roleListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=roleListView!./src/pages/RoleMgmt/RoleList/RoleListView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=roleListView!./src/pages/RoleMgmt/RoleList/RoleListView.js
// module chunks = 43